import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Grid,
    Box,
    Typography,
    Autocomplete,
    TextField,
    Paper
} from '@mui/material';
import StyledTextField from '../../../components/UIComponents/StyledTextField';
import StyledAutocomplete from '../../../components/UIComponents/StyledAutocomplete';
import CustomButton from '../../../components/Buttons';
import theme from "../../../assets/theme"
import moment from 'moment';
import dayjs from 'dayjs';
const RoomBlockingPopup = ({
    open,
    onClose,
    onSave,
    formData,
    setFormData,
    issueCategories = [],
    roomsOptions = [],
    mode
}) => {

    const [isToDateChanged, setIsToDateChanged] = useState(false);

    useEffect(()=>{
        setIsToDateChanged(false);
    },[open])


    const isViewMode = mode === "view";
    const isEditMode = mode === "edit";
    const handleChange = (key, value) => {
        console.log("formdata", formData);
        if (key === "to_date") {
            if (value !== formData.to_date) {
                setIsToDateChanged(true); // ✅ show the button if changed
            }
        }
        setFormData((prev) => ({
            ...prev,
            [key]: value
        }));
        console.log("formdata", formData);
    };


    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    borderRadius: "16px",
                    overflowY: "auto",
                    overflowX: "hidden",
                    backgroundColor: "light.main"
                },
            }}
        >      <DialogTitle>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Typography variant='SubTitleBold'>
                        {mode === 'add' ? 'Add Room Block' : mode === 'edit' ? 'Update Room Block' : 'View Details'}
                    </Typography>

                </Box>


            </DialogTitle>
            <Box
                sx={{
                    border: `1px solid ${theme.palette.gray.main}`,
                    borderRadius: '16px',
                    padding: theme.spacing(1),
                    paddingBottom: theme.spacing(1),
                    mx: 2,
                }}>
                <DialogContent>
                    <Box >
                        <Grid container spacing={0.8}>
                            {mode === "add" ? (
                                <>
                                    <Grid item size={{ xs: 6, md: 6 }}>
                                        <Typography
                                            variant="bodyText1"
                                            sx={{ color: 'dark.main', mb: 0.5 }}
                                        >
                                            Room No.
                                        </Typography>
                                        <Autocomplete
                                            fullWidth
                                            disabled={isViewMode || isEditMode}
                                            options={roomsOptions}
                                            value={formData.room_no || null}
                                            onChange={(e, newValue) => handleChange('room_no', newValue)}
                                            getOptionLabel={(option) => option.room_name || ""}
                                            PaperComponent={(props) => (
                                                <Paper
                                                    {...props}
                                                    sx={{
                                                        '& .MuiAutocomplete-option:hover': {
                                                            backgroundColor: '#E1EFFF!important',
                                                        },
                                                        borderRadius: '8px',
                                                        backgroundColor: 'lightred.main',
                                                    }}
                                                />
                                            )}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder="Room No."
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            borderRadius: theme.borderRadius.medium,
                                                            backgroundColor: 'lightgray.main',
                                                        },
                                                    }}
                                                />
                                            )}
                                        />
                                    </Grid>

                                    <Grid item size={{ xs: 6, md: 6 }}>
                                        <Typography
                                            variant="bodyText1"
                                            sx={{ color: 'dark.main', mb: 0.5 }}
                                        >
                                            Reason
                                        </Typography>
                                        <Autocomplete
                                            fullWidth
                                            disabled={isViewMode || isEditMode}
                                            options={issueCategories}
                                            value={formData.reason || null}
                                            onChange={(e, newValue) => handleChange('reason', newValue)}
                                            getOptionLabel={(option) => option.reason_name || ""}
                                            PaperComponent={(props) => (
                                                <Paper
                                                    {...props}
                                                    sx={{
                                                        '& .MuiAutocomplete-option:hover': {
                                                            backgroundColor: '#E1EFFF!important',
                                                        },
                                                        borderRadius: '8px',
                                                        backgroundColor: 'lightred.main',
                                                    }}
                                                />
                                            )}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder="Issue Category"
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            borderRadius: theme.borderRadius.medium,
                                                            backgroundColor: 'lightgray.main',
                                                        },
                                                    }}
                                                />
                                            )}
                                        />
                                    </Grid>
                                </>

                            ) : (
                                <>
                                    <Grid item size={{ xs: 6 }}>
                                        <StyledTextField
                                            value={formData.room_no}
                                            disabled
                                            label="Room No."
                                            type="text"
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{
                                                max: formData.to_date
                                            }}
                                        />
                                    </Grid>
                                    <Grid item size={{ xs: 6 }}>
                                        <StyledTextField
                                            value={formData.reason}
                                            disabled
                                            label="Reason"
                                            type="text"
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{
                                                max: formData.to_date
                                            }}
                                        />
                                    </Grid>
                                </>

                            )
                            }

                            <Grid item size={{ xs: 6 }}>
                                <StyledTextField
                                    value={formData.from_date}
                                    label="From Date"
                                    type="date"
                                    disabled={isEditMode}
                                    InputLabelProps={{ shrink: true }}
                                    onChange={(e) => handleChange('from_date', e.target.value)}
                                    inputProps={{
                                        max: formData.to_date
                                    }}
                                />
                            </Grid>


                            <Grid item size={{ xs: 6 }}>
                                <StyledTextField
                                    value={formData.to_date}
                                    label="To Date"
                                    type="date"
                                    InputLabelProps={{ shrink: true }}
                                    onChange={(e) => handleChange('to_date', e.target.value)}
                                    inputProps={{
                                        min: formData.from_date
                                    }}
                                />
                            </Grid>


                            <Grid item size={{ xs: 6, md: 12 }}>
                                <StyledTextField
                                    label="Description"
                                    disabled={isViewMode || isEditMode}
                                    multiline
                                    minRows={3}
                                    fullWidth
                                    value={formData.description}
                                    onChange={(e) => handleChange('description', e.target.value)}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </DialogContent>
            </Box>

            <Box mb={2} mr={1}>
                <DialogActions sx={{ pb: 2 }}>
                    <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
                        {formData?.status === "Completed" && (
                            <Box display="flex" alignItems="center" paddingLeft={2} gap={1}>
                                <Typography variant="subHeading">Resolved On:</Typography>

                                <Typography variant="subHeading">{moment(formData?.resolved_time).format("YYYY-MM-DD hh:mm A")}</Typography>
                            </Box>
                        )}

                        {mode === 'edit' && (
                            <Box width="100%" mt={1} display="flex" justifyContent="flex-end" gap={2}>
                                <CustomButton
                                    size="medium"
                                    variant="primaryColor"
                                    onClick={onClose}
                                    sx={{
                                        borderRadius: 2,
                                        border: `2px solid ${theme.palette.primary.main}`,
                                        backgroundColor: "light.main",
                                        color: "primary.main",
                                        width: 120,
                                        height: 36,
                                    }}
                                >
                                    Close
                                </CustomButton>

                                {isToDateChanged && (
                                    <CustomButton
                                        onClick={() => {
                                            onSave({
                                                ...formData,
                                            });
                                            // setIsToDateChanged(false); // ✅ reset after save
                                        }}
                                        size="medium"
                                        variant="primaryColor"
                                        sx={{
                                            borderRadius: 2,
                                            border: `1px solid gray.main`,
                                            backgroundColor: "primary.main",
                                            color: "light.primary",
                                            width: 160,
                                            height: 36,
                                        }}
                                    >
                                        Update
                                    </CustomButton>
                                )}

                            </Box>
                        )}



                        <Box display="flex" gap={1} ml="auto" mt={2} mb={-2}>
                            {mode === 'add' && (
                                <>
                                    <CustomButton
                                        size="medium"
                                        variant="primaryColor"
                                        onClick={onClose}
                                        sx={{
                                            borderRadius: 2,
                                            border: `2px solid ${theme.palette.primary.main}`,
                                            backgroundColor: "light.main",
                                            color: "primary.main",
                                            width: 120,
                                            height: 36,
                                        }}
                                    >
                                        Cancel
                                    </CustomButton>
                                    <CustomButton
                                        onClick={() => onSave({ ...formData, status: "Active" })}
                                        size="medium"
                                        variant="primaryColor"
                                        sx={{
                                            borderRadius: 2,
                                            border: `1px solid gray.main`,
                                            backgroundColor: "primary.main",
                                            color: "light.primary",
                                            width: 120,
                                            height: 36,
                                        }}
                                    >
                                        Block
                                    </CustomButton>
                                </>
                            )}


                            {/* {isViewMode && (
                                <>
                                    <CustomButton
                                        size="medium"
                                        variant="primaryColor"
                                        onClick={onClose}
                                        sx={{
                                            borderRadius: 2,
                                            border: `2px solid ${theme.palette.primary.main}`,
                                            backgroundColor: "light.main",
                                            color: "primary.main",
                                            width: 120,
                                            height: 36,
                                        }}
                                    >
                                        Cancel
                                    </CustomButton>
                                </>
                            )} */}
                        </Box>
                    </Box>
                </DialogActions>
            </Box>
        </Dialog>
    );
};

export default RoomBlockingPopup;
